import type { ErrorMap } from '@/app/error-registry';

export const INVITATIONS_ERROR_MAP: ErrorMap = {
  POST: {
    'Member.AlreadyExists': 'members:apiErrors.alreadyExists',
    'Member.ClientIdRequired': 'members:apiErrors.clientIdRequired',
    'Member.ClientIdNotAllowed': 'members:apiErrors.clientIdNotAllowed',
    'Member.ClientNotInTenant': 'members:apiErrors.clientNotInTenant',
    'Invitation.AlreadyExists': 'members:apiErrors.invitationAlreadyExists',
    'Invitation.MemberLimitExceeded': 'members:apiErrors.memberLimitExceeded',
    default: 'members:apiErrors.inviteDefault',
  },
  DELETE: {
    'Invitation.NotFound': 'members:apiErrors.invitationNotFound',
    default: 'members:apiErrors.cancelInviteDefault',
  },
};

export const MEMBERS_ERROR_MAP: ErrorMap = {
  PATCH: {
    'Member.NotFound': 'members:apiErrors.notFound',
    'Member.CannotDeactivateOwner': 'members:apiErrors.cannotDeactivateOwner',
    'Member.CannotChangeOwnerRole': 'members:apiErrors.cannotChangeOwnerRole',
    'Member.ClientIdRequired': 'members:apiErrors.clientIdRequired',
    'Member.ClientIdNotAllowed': 'members:apiErrors.clientIdNotAllowed',
    'Member.ClientNotInTenant': 'members:apiErrors.clientNotInTenant',
    default: 'members:apiErrors.updateDefault',
  },
  DELETE: {
    'Member.NotFound': 'members:apiErrors.notFound',
    'Member.CannotRemoveOwner': 'members:apiErrors.cannotRemoveOwner',
    default: 'members:apiErrors.deleteDefault',
  },
};

/** Registered against a pattern more specific than `MEMBERS_ERROR_MAP`'s — see error-registry.ts. */
export const MEMBERS_HIRE_DATE_ERROR_MAP: ErrorMap = {
  PUT: {
    'Member.NotFound': 'members:apiErrors.notFound',
    default: 'members:apiErrors.hireDateDefault',
  },
};
